// @flow
// import RadioSelect from 'fg-frontend/src/components/RadioSelect';
// import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
// import Typeahead from 'fg-frontend/components/Typeahead';

/* import SelectDesign from './components/SelectDesign';
// import Tooltip from './components/Tooltip';
// import TriggerInViewport from './components/TriggerInViewport';
// import Countdown from './components/Countdown';
// import Execute from './components/Execute';
// import FGUpload from './components/FGUpload';
// import configureEshopComponents from './configureEshopComponents'; */
// import SimpleCollapse from './components/SimpleCollapse';
// import AddSvgIconSprite from './components/AddSvgIconSprite';
// import PhotoSwipe from './components/PhotoSwipe';
// import WebGtmHandler from './components/WebGtmHandler';
// import GtmHandler from './components/GtmHandler';
// import Toggler from './components/Toggler';
// import ItemSlider from './components/ItemSlider';
// import Webslider from './components/Webslider';
// import GoogleMap from './components/GoogleMap';
// import HideMessage from './components/HideMessage';
// import Poll from './components/Poll';
// import ShowMorePhotos from './components/ShowMorePhotos';
// import HistoryBack from './components/HistoryBack';
// import UserCreditsTank from './components/UserCreditsTank';
// import DataLayer from './components/DataLayer';
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
import 'flatpickr/dist/l10n/cs';
// import Leaderboard from './components/Leaderboard';
// import EshopFulltextAutocomplete from './components/EshopFulltextAutocomplete';
// import GoogleRecaptcha from "fg-frontend/src/components/GoogleRecaptcha";

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'RadioSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'UserCreditsTank':
      return import('./components/UserCreditsTank');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'WebGtmHandler':
      return import('./components/WebGtmHandler');
    case 'GtmHandler':
      return import('./components/GtmHandler');
    case 'Toggler':
      return import('./components/Toggler');
    case 'ItemSlider':
      return import('./components/ItemSlider');
    case 'Webslider':
      return import('./components/Webslider');
    case 'GoogleMap':
      return import('./components/GoogleMap');
    case 'HideMessage':
      return import('./components/HideMessage');
    case 'Poll':
      return import('./components/Poll');
    case 'Typeahead':
      return import('fg-frontend/components/Typeahead');
    case 'Datepicker':
      return Datepicker;
    case 'ShowMorePhotos':
      return import('./components/ShowMorePhotos');
    case 'DataLayer':
      return import('./components/DataLayer');
    case 'SimpleCollapse':
      return import('./components/SimpleCollapse');
    case 'Leaderboard':
      return import('./components/Leaderboard');
    case 'HistoryBack':
      return import('./components/HistoryBack');
    case 'EshopFulltextAutocomplete':
      return import('./components/EshopFulltextAutocomplete');
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js